import "./TermsOfService.module.css";
import Header from "@/reusable_sections/Header";
import NoticeHero from "./sections/NoticeHero";
import DetailedTerms from "./sections/DetailedTerms";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServicePage() {
  return <div>
      <Header />
      <NoticeHero />
      <DetailedTerms />
      <Footer />
    </div>;
}